import InfoPopUp from './InfoPopUp';

export default InfoPopUp;
